import React from "react";
import { Link } from "react-router-dom";


function Footer() {
    return (
        <footer style={{
            background: "#333",
            color: "#fff",
            textAlign: "center",
            padding: "10px",
            position: "relative",
            bottom: 0,
            zIndex: 1000,
        }}>
            <div style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
                © {new Date().getFullYear()} DunderDebunk
                <Link to="/privacy-policy" style={{ color: "#4fc3f7", textDecoration: "underline", gap: "10px" }}>
                    Privacy Policy
                </Link>
            </div>

        </footer>
    );
}

export default Footer;
